<template>
  <div class="files-wrap">
    <h3 class="files-wrap__title mb-2">{{ title }}</h3>
    <p
      class="messages__message v-messages error--text my-2"
      v-if="showingHintUploadServer"
    >
      {{ $t("validation.document_file_hint") }}
    </p>
    <p class="mt-1" v-if="files.length === 0">{{ $t("noDataAvailable") }}</p>
    <div class="d-flex flex-wrap ma-n2">
      <div
        @click="openFile(file)"
        :key="`file-${fileIndex}`"
        v-for="(file, fileIndex) in allFiles"
        class="pa-2"
      >
        <div class="d-flex">
          <v-btn
            class="elevation-0"
            @click.stop="downloadFile(file)"
            icon
            data-test="filesWrap-download-btn"
          >
            <vue-icon icon="requestIcon" />
          </v-btn>
          <div class="files-wrap__box" :style="{ maxWidth: maxBoxSize + 'px' }">
            <span class="files-wrap__box__label">{{ file.name }}</span>
            <v-btn
              data-test="filesWrap-delete-btn"
              v-if="accessDelete"
              @click.stop="deleteFile(fileIndex)"
              icon
              class="ml-2"
              style="color: var(--error)"
            >
              <vue-icon class="" icon="deleteIcon"></vue-icon>
            </v-btn>
          </div>
        </div>
        <span
          class="messages__message v-messages error--text"
          v-if="!file.isValid"
          >{{ $t("validation.document_file") }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import "./files-wrap.scss";
import { downloadBlobFile, isFileDocument } from "@/utils/pureFunctions";

export default {
  name: "FilesWrap",
  props: {
    accessDelete: {
      type: Boolean,
      default: false,
    },
    showingHintUploadServer: {
      type: Boolean,
      default: false,
    },
    maxBoxSize: {
      type: Number,
      default: 150,
    },
    title: {
      type: String,
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async downloadFile(item) {
      if (item.file) {
        downloadBlobFile(item.file, item.name);
      } else if (item.link) {
        try {
          const file = await this.$store.dispatch(
            "getAttachmentFile",
            item.link
          );
          downloadBlobFile(file, item.name);
        } catch (e) {
          this.setResponseError({ error: e });
        }
      }
    },
    deleteFile(index) {
      let files = [...this.files];
      this.$emit("deleted", files[index]);
      files.splice(index, 1);
      this.$emit("update:files", files);
    },
    async openFile(item) {
      if (item.link) {
        try {
          const data = await this.$store.dispatch("getAttachmentFileBase64", {
            link: item.link,
          });
          this.$emit("showFile", {
            images: data.base64s,
            name: item.link,
            total: data.total,
          });
        } catch (e) {
          this.setResponseError({ error: e });
        }
      } else if (item.pages) {
        this.$emit("showFile", { images: item.pages });
      }
    },
  },
  computed: {
    allFiles() {
      return this.files.map((item) => {
        if (item.file) {
          item.isValid = isFileDocument(item.file);
        } else {
          item.isValid = true;
        }
        return item;
      });
    },
  },
};
</script>
